import { render } from "./INodeList.vue?vue&type=template&id=5227a0ce&scoped=true"
import script from "./INodeList.vue?vue&type=script&lang=ts"
export * from "./INodeList.vue?vue&type=script&lang=ts"

import "./INodeList.vue?vue&type=style&index=0&id=5227a0ce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5227a0ce"

export default script